import { CloseOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Modal, Space, Spin, Tooltip, Typography, message } from "antd";
import { useCallback, useEffect, useState } from "react";
import { serverFetch } from "../../core/server";
import "./database-blocks.css";

const formatWhen = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString("ru-RU");
};

const DatabaseSessions = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadItems = useCallback(async () => {
    setLoading(true);
    try {
      const result = await serverFetch("app/database/sessions");
      setItems(Array.isArray(result) ? result : []);
    } catch (e) {
      setItems([]);
      message.error(e.userMessage || e.message || "Не удалось загрузить сессии");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  const closeSession = (row) => {
    Modal.confirm({
      title: "Закрыть сессию?",
      content: row.userName ? `${row.userName} будет разлогинен.` : "Пользователь будет разлогинен.",
      okText: "Закрыть",
      okButtonProps: { danger: true },
      cancelText: "Отмена",
      onOk: async () => {
        await serverFetch(`app/database/sessions/${row.id}`, { method: "DELETE" });
        message.success("Сессия закрыта");
        await loadItems();
      }
    });
  };

  return (
    <div>
      <div className="db-toolbar">
        <Space>
          <Button icon={<ReloadOutlined />} onClick={loadItems}>
            Обновить
          </Button>
        </Space>
        <Typography.Text type="secondary">Открыто: {items.length}</Typography.Text>
      </div>
      <Spin spinning={loading}>
        {items.length === 0 ? (
          <Typography.Paragraph type="secondary" style={{ marginTop: 12 }}>
            Нет открытых сессий.
          </Typography.Paragraph>
        ) : (
          <div className="db-blocks">
            {items.map((row) => (
              <div key={row.id} className="db-block">
                <div className="db-block__body">
                  <div className="db-block__title">
                    <span className="db-block__title-text">{row.userName || `Пользователь ${row.userId}`}</span>
                  </div>
                  <div className="db-block__meta">
                    <span>{formatWhen(row.createdOn)}</span>
                    {row.ip ? <span>{row.ip}</span> : null}
                    {row.isDealer ? <span>дилер</span> : null}
                  </div>
                </div>
                <div className="db-block__actions">
                  <Tooltip title="Закрыть">
                    <Button type="text" size="small" danger icon={<CloseOutlined />} onClick={() => closeSession(row)} />
                  </Tooltip>
                </div>
              </div>
            ))}
          </div>
        )}
      </Spin>
    </div>
  );
};

export default DatabaseSessions;
